import { frontendURL } from '../../../helper/URLHelper';
import SettingsWrapper from '../settings/SettingsWrapper.vue';
import AgentsSettings from './pages/AgentsSettings.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/settings/ai-insights'),
    component: SettingsWrapper,
    children: [
      {
        path: '',
        redirect: to => ({
          name: 'ai_insights_agents_settings',
          params: to.params,
        }),
      },
      {
        path: 'agents',
        name: 'ai_insights_agents_settings',
        component: AgentsSettings,
        meta: {
          permissions: ['administrator'],
        },
      },
    ],
  },
];
